var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "room-listing" },
    [
      _c("filters", { attrs: { filters: _vm.filters } }),
      _vm._v(" "),
      _c("listing-view", {
        attrs: { "listings-type": _vm.listings, theme: _vm.theme },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }